var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white"},[_c('div',{staticClass:"padding-lr"},[_c('h3',{staticClass:"notice-title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"notice-time"},[_vm._v(_vm._s(_vm.time))]),_c('div',{staticClass:"notice-detial",domProps:{"innerHTML":_vm._s(_vm.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }